module.exports = new __parcel__URL__("WevrWatermark.631d8fcc.svg").toString();